module.exports = __webpack_public_path__ + "static/flags/MV-b4aefc119a666bd644ba455d7f3ffcd1.gif";